import { render, staticRenderFns } from "./LinkingCamera.vue?vue&type=template&id=28e72572&scoped=true"
import script from "./LinkingCamera.vue?vue&type=script&lang=ts"
export * from "./LinkingCamera.vue?vue&type=script&lang=ts"
import style0 from "./LinkingCamera.vue?vue&type=style&index=0&id=28e72572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e72572",
  null
  
)

export default component.exports